import React from "react";
import { useAdminCompany } from "context/AdminCompanyContext";
import { StatusBadge } from "components/Account/StatusBadge";
import PageHeader from "components/PageLayout";
import PageKpis from "components/PageKpis";
import { Building2, Tag } from "lucide-react";

export default function PortfolioDashboard({ childCompanies }) {
  const { setActiveCompanyId } = useAdminCompany();

  const activeCount = childCompanies.filter((c) => c.status === "active").length;
  const totalFeatures = childCompanies.reduce(
    (sum, c) => sum + (c.features?.length || 0),
    0
  );

  return (
    <>
      <PageHeader title="Portfolio" description="Overview of all your companies" />

      <PageKpis
        items={[
          {
            label: "Companies",
            value: childCompanies.length,
            icon: <Building2 />,
            tone: "brand",
          },
          {
            label: "Active",
            value: activeCount,
            icon: <Building2 />,
            tone: "success",
          },
          {
            label: "Features Enabled",
            value: totalFeatures,
            icon: <Tag />,
            tone: "info",
          },
        ]}
        columns={{ base: 1, md: 3, lg: 3 }}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {childCompanies.map((child) => (
          <button
            key={child.companyId}
            onClick={() => setActiveCompanyId(child.companyId)}
            className="surface rounded-xl ring-1 ring-border p-6 text-left hover:ring-brand/50 hover:shadow-md transition-all cursor-pointer group"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="p-2 bg-brand/10 rounded-lg group-hover:bg-brand/20 transition">
                <Building2 className="w-5 h-5 text-brand" />
              </div>
              <StatusBadge status={child.status} />
            </div>

            <h3 className="text-base font-semibold text-foreground mb-1">
              {child.name}
            </h3>

            {child.slug && (
              <p className="text-xs text-muted-foreground mb-3">{child.slug}</p>
            )}

            {child.features?.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mt-2">
                {child.features.map((f) => (
                  <span key={f} className="badge badge-brand text-xs">
                    {f}
                  </span>
                ))}
              </div>
            )}

            {child.tier && (
              <p className="text-xs text-muted-foreground mt-3 capitalize">
                {child.tier}
              </p>
            )}
          </button>
        ))}
      </div>
    </>
  );
}
